import ActivityItem from '../components/CalendarActivityItem';

export const getCalendarActivityDescription = ({ activity, name }) => {
	const actor = name ? ` by ${name}` : '';

	if (activity === 'created') {
		return `New Calendar Event Added${actor}`;
	}
	if (activity === 'edited') {
		return `Calendar Event Edited${actor}`;
	}
	return `Calendar Event Deleted${actor}`;
};

export function useCalendarActivityMapper(lastPostActivityId) {
	return (val, index, arr) => {
		const description = getCalendarActivityDescription(val);

		return (
			<ActivityItem
				key={val.id}
				activity={{
					...val,
					description,
					index,
					only: arr.length === 1 && index === 0,
					last: !lastPostActivityId && index === arr.length - 1,
				}}
			/>
		);
	};
}
